import React, {Component} from 'react'
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {CCModalLayout,ClaimReward, Notifications,CCActions,CCBackLayout,} from './../../cc-imports'


class NotificationsModal extends Component {

    static propTypes = {}

    static defaultProps = {}

    constructor(props) {
        super(props)
        this.state = {
            skip: 0,
            screen: 'ntfns',
            claimNtfn: {}
        }
        this._claimPressed = this._claimPressed.bind(this);
        this._changeScreen = this._changeScreen.bind(this);
    }

    _closeModal() {
        this.props.actions.closeModal("Notifications");
    }

    _changeScreen(screen) {
        this.setState({screen});
    }

    _claimPressed({claimNtfn}) {
        this.setState({claimNtfn});
        this._changeScreen('claim');
    }

    render() {
        const {screen} = this.state;


        return (
            <CCModalLayout name={"Notifications"}>
                {
                    screen=='ntfns' &&
                        <Notifications claimPressed={this._claimPressed}> </Notifications>
                }
                {
                    screen == 'claim' &&
                    <CCBackLayout onBackPress={()=>{this._changeScreen('ntfns')}}>
                        <ClaimReward ntfn={this.state.claimNtfn}></ClaimReward>
                    </CCBackLayout>
                }


            </CCModalLayout>
        )
    }
}

export default connect(state => ({
        modals: state.modals,
        user: state.user,
        byId: state.notifications.byId,
        byUserId: state.notifications.byUserId,

        pages: state.notifications.pages,
        userId: state.user.id,
        //userId: '5a447f1edf0e0257e62d6d1f',
        random: state.notifications.random,
        type: state.notifications.type,
        reqStatus: state.notifications.reqStatus
    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(NotificationsModal);


// WEBPACK FOOTER //
// ./src/app/modals/NotificationsModal/NotificationsModal.js